import React from 'react'
import ClickOutHandler from 'react-onclickout'
import { getStaticImage } from 'utils/statics'
import { I18n } from 'react-redux-i18n'
import useFilterMenu from './useFilterMenu'
import './styles.scss'

const FilterMenu = ({ customClassName, withSearch = true }) => {
  const {
    isOpenOptions,
    searchText,
    handleToggleOptions,
    handleFiltersMessages,
    handleResetFilter,
    getFilterOptions,
  } = useFilterMenu()

  return (
    <div className={`filter-menu ${customClassName || ''}`}>
      <button
        type='button'
        className='filter-menu__btn'
        onClick={handleToggleOptions}
      >
        <figure className='filter-menu__icon filter-menu__icon--filter'>
          {(searchText || getFilterOptions().some(option => option.value)) ? (
            <img src={getStaticImage('/icons/orange-brand/icon-filter-active-primary.svg')} alt='Active filter' />
          ) : (
            <img src={getStaticImage('/icons/orange-brand/icon-filter-grey.svg')} alt='Clean filter' />
          )}
        </figure>
      </button>
      {isOpenOptions ? (
        <ClickOutHandler onClickOut={handleToggleOptions}>
          <div className='filter-menu__options-menu'>
            {withSearch ? (
              <div className='filter-menu__search-container'>
                <figure className='filter-menu__icon filter-menu__icon--search'>
                  <img src={getStaticImage('/icons/orange-brand/icon-search-grey.svg')} alt='Search' />
                </figure>
                <input
                  type='text'
                  placeholder={I18n.t('dashboard_filter-by-text')}
                  value={searchText || ''}
                  onChange={({ target: { value } }) => handleFiltersMessages('text', value)}
                />
                {searchText ? (
                  <button
                    type='button'
                    className='filter-menu__btn'
                    onClick={() => handleFiltersMessages('text', '')}
                  >
                    <figure className='filter-menu__icon filter-menu__icon--close'>
                      <img src={getStaticImage('/icons/orange-brand/icon-close.svg')} alt='Clean' />
                    </figure>
                  </button>
                ) : null}
              </div>
            ) : null}
            {getFilterOptions().map((option, index) => (
              <button
                type='button'
                key={index}
                className='filter-menu__btn filter-menu__option-btn'
                onClick={() => handleFiltersMessages(option.type, !option.value)}
              >
                <figure className='filter-menu__icon'>
                  <img src={getStaticImage(`/icons/orange-brand/${option.iconName}.svg`)} alt={option.iconName}/>
                </figure>
                <p
                  className={`filter-menu__text text-ellipsis ${option.value ? 'filter-menu__text--active' : ''}`}
                  title={option.name}
                >
                  {option.name}
                </p>
                {option.value ? (
                  <figure className='filter-menu__icon'>
                    <img src={getStaticImage(`/icons/orange-brand/icon-check-primary-dark.svg`)} alt="check"/>
                  </figure>
                ) : null}
              </button>
            ))}
            <button
              type='button'
              className='filter-menu__btn filter-menu__option-btn'
              onClick={() => {
                handleResetFilter()
                handleToggleOptions()
              }}
            >
              <figure className='filter-menu__icon'>
                <img src={getStaticImage('/icons/orange-brand/icon-close-red.svg')} alt="close" />
              </figure>
              <p className='filter-menu__text filter-menu__text--reset text-ellipsis'>
                {I18n.t('dashboard_reset-filters')}
              </p>
            </button>
          </div>
        </ClickOutHandler>
      ) : null}
    </div>
  )
}

export default FilterMenu
